import {Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {CardTemplateComponent} from '../card-template/card-template.component';
import {AnnouncementCardComponent} from '../../cards/student/announcement-card/announcement-card.component';
import {AttendanceCardComponent} from '../../cards/student/attendance-card/attendance-card.component';
import {AssignmentsCardComponent} from '../../cards/student/assignments-card/assignments-card.component';
import {CurrentGradesCardComponent} from '../../cards/student/current-grades-card/current-grades-card.component';
import {DistrictDefinedLinksCardComponent} from '../../cards/student/district-defined-links-card/district-defined-links-card.component';
import {FeesBillingCardComponent} from '../../cards/student/fees-billing-card/fees-billing-card.component';
import {MealServiceCardComponent} from '../../cards/student/meal-service-card/meal-service-card.component';
import {StudentScheduleCardComponent} from '../../cards/student/student-schedule-card/student-schedule-card.component';
import {UpcomingEventsCardComponent} from '../../cards/student/upcoming-events-card/upcoming-events-card.component';
import {Card} from './card';
import {CalendarCardComponent} from '../../cards/student/calendar-card/calendar-card.component';
import {AttendanceHistoryCardComponent} from '../../cards/staff/attendance-history-card/attendance-history-card.component';
import {StudentTeamsCardComponent} from '../../cards/staff/student-teams-card/student-teams-card.component';
import {StudentNotesCardComponent} from '../../cards/staff/student-notes-card/student-notes-card.component';
import {BehaviorCardComponent} from '../../cards/staff/behavior-card/behavior-card.component';
import {ProgramsAndServicesCardComponent} from '../../cards/staff/programs-and-services-card/programs-and-services-card.component';
import {StudentDetailsCardComponent} from '../../cards/staff/student-details-card/student-details-card.component';
import {EnrollmentCardComponent} from '../../cards/staff/enrollment-card/enrollment-card.component';
import {ContactsCardComponent} from '../../cards/staff/contacts-card/contacts-card.component';
import {StaffStudentScheduleCardComponent} from '../../cards/staff/staff-student-schedule-card/staff-student-schedule-card.component';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

    @Input() card: Card;
    @ViewChild('container', { read: ViewContainerRef, static: true }) private container: ViewContainerRef;
    readonly templateMapper = {
        announcementCard: AnnouncementCardComponent,
        attendanceCard: AttendanceCardComponent,
        assignmentsCard: AssignmentsCardComponent,
        currentGradesCard: CurrentGradesCardComponent,
        districtDefinedLinksCard: DistrictDefinedLinksCardComponent,
        feesAndBillingCard: FeesBillingCardComponent,
        mealServiceCard: MealServiceCardComponent,
        studentScheduleCard: StudentScheduleCardComponent,
        upcomingEventsCard: UpcomingEventsCardComponent,
        calendarCard: CalendarCardComponent,
        attendanceHistoryCard: AttendanceHistoryCardComponent,
        studentTeamsCard: StudentTeamsCardComponent,
        studentNotesCard: StudentNotesCardComponent,
        behaviorCard: BehaviorCardComponent,
        programsAndServicesCard: ProgramsAndServicesCardComponent,
        studentDetailsCard: StudentDetailsCardComponent,
        enrollmentCard: EnrollmentCardComponent,
        contactsCard: ContactsCardComponent,
        staffStudentScheduleCard: StaffStudentScheduleCardComponent
    };

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        this.loadCards();
    }

    private getComponentForCardType(component) {
        return this.templateMapper[component];
    }

    loadCards() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponentForCardType(this.card.component));
        const viewContainerRef = this.container;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (<CardTemplateComponent>componentRef.instance).data = this.card;
    }
}
